const paymentLinkStyles = () => ({
  modal: {
    '& .ant-modal-content': {
      borderRadius: 4,
    },
    '& .ant-modal-header': {
      borderBottom: '1px solid #E8E8E8',
      padding: '16px 24px',
    },
    '& .ant-modal-title': {
      fontSize: '18px',
      fontWeight: 500,
    },
    '& .ant-modal-body': {
      padding: '20px 24px',
      height: '500px',
      overflowY: 'auto',
    },
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#000000',
  },
  closeIcon: {
    fontSize: 20,
  },
  warningNote: {
    backgroundColor: '#fffbe6',
    padding: '12px 16px',
    borderRadius: 4,
    marginBottom: 20,
  },
  warningText: {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.85)',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 24,
    gap: 12,
  },
  cancelButton: {
    border: '1px solid #d9d9d9',
  },
  proceedButton: {
    backgroundColor: '#1e3a8a', // Navy blue color similar to the screenshot
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#1e40af',
    },
  },
  changeLocationButton: {
    backgroundColor: '#1e3a8a',
    color: 'white',
    padding: '8px 16px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#1e40af',
    },
  },
  container: {
    padding: 20,
  },
  main: {
    '& .ant-input-number-input': {
      borderRadius: 4,
      width: '100%',
    },
    '.anticon svg': {
      color: '#eeeeee',
    },
    '& .ant-form-item': {
      margin: 0,
      padding: 0,
    },
  },
  quantityRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
  },
  selectLabel: {
    font: 'Open Sans Regular',
    fontSize: 10,
    marginBottom: 6,
    letter: 'normal',
  },
  itemName: {
    font: 'Open Sans SemiBold',
    fontSize: 10,
  },
  inputQuantityCol: {
    padding: '0 4px',
  },
  inputQuantity: {
    // Add properties here as needed
  },
});

export default paymentLinkStyles;